import { render, staticRenderFns } from "./EditableProducts.vue?vue&type=template&id=e54aef1e&"
import script from "./EditableProducts.vue?vue&type=script&lang=js&"
export * from "./EditableProducts.vue?vue&type=script&lang=js&"
import style0 from "./EditableProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports